<template>
<div container--fluid>
    <v-layout>
        <ProductModule orig="hpc"></ProductModule>
    </v-layout>
</div>
</template>

<script>
import ProductModule from '@modules/product/index.vue';

export default {
    name: 'product',
    components: {
        ProductModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
